module.exports = __webpack_public_path__ + "img/infusion.4e9ba3cc.svg";